<template>
    <div>
        <!-- Leitura Amostras -->
        <div class="modal fade" id="lerAmostrasAPModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Amostras</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="lista">

                        <az-input
                            v-if="!only_amostras"
                            class="mb-3"
                            type="button-group"
                            :optionsList="[
                                { id: 'F', search: 'Fluxo' }, 
                                { id: 'A', search: 'Arquivo' }
                            ]"
                            optionsData="id"
                            v-model="tipo_leitura" />

                        <!-- Fila de Fluxo -->

                        <template v-if="tipo_leitura == 'F'">

                            <div class="list-group mb-3" v-if="fila">
                                <template v-if="status_selec">
                                    <button type="button" class="list-group-item list-group-item-action active" :class="'list-group-item-' + status_selec.st_color"
                                        :disabled="$store.state.loading" @click="selecionar_status()">
                                        {{ status_selec.st_acao }}
                                    </button>
                                </template>

                                <template v-else>
                                    <button type="button" class="list-group-item list-group-item-action" :class="'list-group-item-' + status.st_color"
                                        v-for="(status, isx) in fila.lista_status" :key="isx"
                                        :disabled="$store.state.loading" @click="selecionar_status(status)">
                                        {{ status.st_acao }}
                                    </button>
                                </template>
                            </div>

                        </template>

                        <!-- Fila de Arquivo -->

                        <template v-else>

                            <div class="list-group mb-3" v-if="lista_status_amostra">
                                <template v-if="status_selec_arquivo">
                                    <button type="button" class="list-group-item list-group-item-action active" :class="'list-group-item-' + status_selec_arquivo.st_color"
                                        :disabled="$store.state.loading" @click="selecionar_status()">
                                        {{ status_selec_arquivo.search }}
                                    </button>
                                </template>

                                <template v-else>
                                    <button type="button" class="list-group-item list-group-item-action" :class="'list-group-item-' + status.st_color"
                                        v-for="(status, isx) in lista_status_amostra" :key="isx"
                                        :disabled="$store.state.loading" @click="selecionar_status(status)">
                                        {{ status.search }}
                                    </button>
                                </template>
                            </div>

                        </template>

                        <!-- Leitura do Código de Barras -->

                        <template v-if="!fila || status_selec || status_selec_arquivo">

                            <div v-if="status_selec_arquivo && status_selec_arquivo.fl_info_prazo && !status_selec_arquivo.in_tempo_prazo">
                                <az-sub-title title="Prazo de Armazenamento da Amostra" class="mt-3" />
                                <div class="form-row">
                                    <div class="col col-12 col-md-4">
                                        <az-input
                                            sizing="sm"
                                            type="date"
                                            required
                                            :validate="validate"
                                            v-model="status_selec_arquivo.dt_prazo" />
                                    </div>
                                    <div class="col col-12 col-md-8">
                                        <button type="button" class="btn btn-outline-primary btn-sm" @click="definir_prazo(1, 'w')">1 semana</button>
                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="definir_prazo(3, 'M')">3 meses</button>
                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="definir_prazo(5, 'y')">5 anos</button>
                                        <button type="button" class="btn btn-outline-primary btn-sm ml-1" @click="definir_prazo(10, 'y')">10 anos</button>
                                    </div>
                                </div>
                            </div>

                            <div v-if="status_selec_arquivo && status_selec_arquivo.js_formulario">
                                <az-sub-title title="Informações" class="mt-3" />
                                <formulario 
                                    v-model="status_selec_arquivo.js_formulario" 
                                    :saved="false" 
                                    :validate="validate"
                                    mode="fixed"
                                    :config="true" />
                            </div>

                            <div v-if="status_selec && status_selec.id_modelo_prontuario && modelo && modelo.doc_pre_atend">
                                <az-sub-title :title="modelo.search" class="mt-3" />
                                <formulario 
                                    v-if="modelo && modelo.doc_pre_atend"
                                    :compact="modelo.doc_pre_atend.fl_compact"
                                    v-model="modelo.doc_pre_atend.js_conteudo" 
                                    :saved="false" 
                                    :validate="validate"
                                    mode="fixed"
                                    :config="true" />
                            </div>

                            <div v-if="status_selec && status_selec.fl_info_resp && resps">
                                <az-sub-title title="Responsáveis" class="mt-3" />
                                <laudo-usuario-form :laudo="resps" :validate="validate" />
                            </div>

                            <div class="form-row my-3">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        type="select"
                                        icon="fa-solid fa-barcode"
                                        placeholder="Tipo de Etiqueta..."
                                        optionsMode="aql"
                                        optionsName="tipo-etiqueta-amostras-lista-peca"
                                        service="tipo_etiqueta_amostras.index"
                                        optionsData="id_tipo_etiqueta_amostra"
                                        :optionsParm="{ ativos: true, filtro_geral: true }"
                                        v-model="id_eta" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        ref="barcode"
                                        icon="fa-solid fa-barcode"
                                        placeholder="Ler amostra..."
                                        v-model="search" 
                                        @onEnter="leitura">
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input 
                                        type="button-group"
                                        :optionsList="[
                                            { id: 'T', search: 'Todos' }, 
                                            { id: 'U', search: 'Único' }
                                        ]"
                                        optionsData="id"
                                        v-model="todos_unico">
                                    </az-input>
                                </div>
                            </div>

                            <ul class="list-group mt-3">
                                <li class="list-group-item py-2" v-for="(amostra, iax) in lista" :key="iax" :class="!amostra.fl_ativo ? 'list-group-item-success' : ''">
                                    
                                    <div class="d-flex justify-content-between">
                                        <div>
                                            <strong>{{ amostra.st_codigo }}</strong>
                                            {{ amostra.st_titulo }}
                                            <span class="badge badge-secondary ml-3">#{{ amostra.id_atendimento }}</span>
                                            <div v-if="amostra.rastro && amostra.rastro.status_rastro">
                                                <span class="badge" :class="'badge-' + amostra.rastro.status_rastro.st_color">
                                                    {{ amostra.rastro.status_rastro.search }}
                                                </span>
                                            </div>
                                        </div>
                                        <div>
                                            <div v-for="(exame, iex) in amostra.exames" :key="iex">
                                                <span class="small text-muted" v-if="exame.atendimento_procedimento && exame.atendimento_procedimento.procedimento">
                                                    {{ exame.atendimento_procedimento.procedimento.st_procedimento }}
                                                </span>
                                                <span class="badge" :class="'badge-' + exame.atendimento_procedimento.laudo.status_laudo.st_color" v-if="exame.atendimento_procedimento.laudo && exame.atendimento_procedimento.laudo.status_laudo">
                                                    {{ exame.atendimento_procedimento.laudo.status_laudo.search }}
                                                </span>
                                            </div>

                                            <div v-if="!amostra.exames.length">
                                                <i class="fa fa-exclamation-triangle text-danger mr-2" aria-hidden="true"></i>
                                                <strong>Não elegível para fila selecionada</strong>
                                            </div>
                                        </div>
                                    </div>

                                    <template v-if="amostra.atend_amostras && amostra.atend_amostras.length > 0">

                                        <table class="table table-sm table-hover mt-3 mb-1">
                                            <tbody>
                                                <tr v-for="(atend_amostra, iax2) in amostra.atend_amostras" :key="iax2" :class="atend_amostra.removida ? 'table-secondary' : ( atend_amostra.lida ? 'table-success' : '' )">
                                                    <td>
                                                        <i class="fa-solid fa-circle-xmark text-danger fa-fw mr-2" v-if="atend_amostra.removida"></i>
                                                        <i class="fa-solid fa-circle-check text-success fa-fw mr-2" v-else-if="atend_amostra.lida"></i>
                                                        <i class="fa-solid fa-circle text-secondary fa-fw mr-2" v-else></i>
                                                        <span class="badge badge-secondary mr-2">{{ iax2 + 1 }}</span>
                                                    </td>
                                                    <td>
                                                        {{ atend_amostra.st_codigo }}    
                                                    </td>
                                                    <td>
                                                        {{ atend_amostra.st_titulo }}
                                                    </td>
                                                    <td>
                                                        <span v-if="atend_amostra.last_rastro && atend_amostra.last_rastro.status_rastro" class="badge" :class="'badge-' + atend_amostra.last_rastro.status_rastro.st_color">
                                                            {{ atend_amostra.last_rastro.status_rastro.search }}
                                                        </span>
                                                    </td>
                                                    <td style="max-width: 100px;">
                                                        <div class="text-nowrap text-truncate small text-muted" style="max-width: 500px;">
                                                            {{ resumo(atend_amostra) }}
                                                        </div>
                                                    </td>
                                                    <td class="text-right">
                                                        <template v-if="!iax">
                                                            <i class="fa fa-times text-secondary" aria-hidden="true" v-if="atend_amostra.lida"></i>
                                                            <a href="#" @click.prevent="atend_amostra.removida = !atend_amostra.removida" v-else>
                                                                <i class="fa fa-times" :class="atend_amostra.removida ? 'text-secondary' : 'text-danger'" aria-hidden="true"></i>
                                                            </a>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot v-if="!iax">
                                                <tr>
                                                    <td colspan="2">
                                                        <span class="badge badge-secondary mr-2" title="Seleciondas / Total">{{ amostra.atend_amostras.filter(amo => amo.lida).length }} / {{ amostra.atend_amostras.filter(amo => !amo.removida).length }}</span>
                                                        <span class="badge badge-danger mr-2" title="Removidas" v-if="amostra.atend_amostras.filter(amo => amo.removida).length">{{ amostra.atend_amostras.filter(amo => amo.removida).length }}</span>
                                                    </td>
                                                    <td colspan="4" class="text-right">
                                                        <az-submit sizing="sm" @click="atualizar(amostra)" v-if="lista && lista.length">
                                                            Todos
                                                        </az-submit>

                                                        <az-submit sizing="sm" @click="atualizar(amostra, true)" v-if="lista && lista.length && ( amostra.atend_amostras.filter(amo => amo.lida).length == 1 )" color="outline-success" class="ml-1">
                                                            Único
                                                        </az-submit>        
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        
                                        <div class="px-3 mb-1" v-if="false">
                                            <div v-for="(atend_amostra, iax2) in amostra.atend_amostras" :key="iax2">
                                                <i class="fa-solid fa-circle-check text-success fa-fw mr-2" v-if="atend_amostra.lida"></i>
                                                <i class="fa-solid fa-circle text-secondary fa-fw mr-2" v-else></i>
                                                <span class="badge badge-secondary mr-2">{{ iax2 + 1 }}</span>
                                                {{ atend_amostra.st_codigo }}
                                                {{ atend_amostra.st_titulo }}
                                            </div>
                                            <div class="text-right" v-if="!iax">
                                                <az-submit @click="atualizar(amostra)" v-if="lista && lista.length">
                                                    Todos
                                                </az-submit>

                                                <az-submit @click="atualizar(amostra, true)" v-if="lista && lista.length && ( amostra.atend_amostras.filter(amo => amo.lida).length == 1 )" color="outline-success" class="ml-1">
                                                    Único
                                                </az-submit>
                                            </div>
                                        </div>

                                    </template>

                                </li>
                            </ul>

                        </template>
                    </div>
                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import * as moment from "moment";
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import LaudoUsuarioForm from './LaudoUsuarioForm.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import Formulario from '../consultorio/Formulario.vue';

export default {
    data() {
        return {
            search: "", 
            lista: null,
            lendo: false, 
            status_selec: null, 
            status_selec_arquivo: null, 
            tipo_leitura: 'F', 
            lista_status_amostra: null, 
            validate: false, 
            resps: null, 
            modelo: null,
            todos_unico: 'T', 
            id_eta: "", 
        }
    },

    props: ['fila', 'only_amostras', 'id_tipo_etiqueta_amostra'], 

    components: { 
        AzInput,
        AzSubmit, 
        LaudoUsuarioForm,
        AzSubTitle, 
        Formulario, 
    },

    watch: { 
        tipo_leitura: { 
            immediate: true, 
            handler (nv) { 
                this.status_selec = null; 
                this.status_selec_arquivo = null; 

                if ( nv == 'A' && ( this.lista_status_amostra === null ) ) { 
                    this.carregar_status_amostra(); 
                }
            }
        }
    },

    methods: { 
        resumo (amostra) { 
            if ( !amostra || !amostra.last_rastro || !amostra.last_rastro.js_formulario || !amostra.last_rastro.js_formulario.length )
                return '';

            return amostra.last_rastro.js_formulario.filter(campo => campo.value)
                .map(campo => {
                    return `${campo.label}: ${campo.value}`;
                })
                .join(' | ');
        },

        remover_amostra (item, lista, idx) { 
            if ( !confirm('Confirma remover o(a) ' + item.st_titulo + ' da lista (' + item.st_codigo + ')?') ) { 
                return; 
            }

            if ( lista && lista.length && ( idx >= 0 ) && ( idx < lista.length ) ) { 
                lista.splice(idx, 1); 
            }
        },

        definir_prazo (tempo, medida) { 
            let date = moment().add(tempo, medida);
            this.status_selec_arquivo.dt_prazo = date.format('YYYY-MM-DD');
        },

        carregar_status_amostra () { 
            this.lista_status_amostra = ""; 

            this.$util.load(this, { 
                service: 'laudos',
                func: 'listar_status_amostra_ap',
                loadTo: res => { 
                    this.lista_status_amostra = ( res && res.lista ) ? res.lista : []; 
                }
            });
        },

        selecionar_status (status = null) { 
            if ( this.tipo_leitura == 'A' ) { 
                if ( this.status_selec_arquivo ) { 
                    this.status_selec_arquivo = null; 
                } else { 
                    this.status_selec_arquivo = _.cloneDeep(status);
                }
            } else { 
                if ( this.status_selec ) { 
                    this.status_selec = null; 
                } else { 
                    this.status_selec = status;
                }
            }

            this.lista = []; 
            this.search = ""; 
            this.lendo = false; 
            this.modelo = null; 
            this.validate = false;

            if ( this.status_selec && this.status_selec.fl_info_resp ) { 
                this.resps = { resps: [] }; 
            } else { 
                this.resps = null; 
            }

            if ( this.status_selec && this.status_selec.id_modelo_prontuario ) { 
                
                this.$util.loadItem(this, { 
                    service: 'laudos',
                    func: 'obter_modelo_ap',
                    parms: { 
                        id_status_laudo: this.status_selec.id_status_laudo 
                    },
                })
                .then(res => { 
                    this.modelo = ( res && res.modelo ) ? res.modelo : null; 
                });
                
            }

        },

        atualizar (amostra, force_unico = false) { 
            amostra.atend_amostras.forEach(a => { 
                if ( !a.removida ) { 
                    a.lida = true
                }
            });

            this.leitura(amostra.st_codigo, force_unico); 
        },

        leitura (codigo = null, force_unico = false) { 

            if ( codigo ) { 
                this.search = codigo;
            }
 
            if ( this.search && ( !isNaN(this.search.slice(1)) && ( !isNaN(this.search.slice(0,1)) || this.search.slice(0,1) == '#' ) ) ) { 

                let existe = false; 
                let lidas = []; 
                let removidas = [];

                if ( this.lista && this.lista.length ) { 

                    let primeiro = _.first(this.lista); 

                    if ( primeiro ) { 

                        if ( primeiro.atend_amostras && primeiro.atend_amostras.length ) { 
                            existe = primeiro.atend_amostras.find(a => a.st_codigo == this.search.trim()); 

                            lidas = primeiro.atend_amostras.filter(a => a.lida)
                                .map(a => a.st_codigo); 

                            removidas = primeiro.atend_amostras.filter(a => !a.lida && a.removida)
                                .map(a => a.st_codigo); 
                        }

                    }

                } 
                
                
                if ( ( this.status_selec && this.tipo_leitura == 'F' ) || ( this.status_selec_arquivo && this.tipo_leitura == 'A' ) ) {  

                    this.$util.atualizar(this, { 
                        service: 'laudos',
                        func: 'ler_amostra_ap',
                        dados: { 
                            codigo: this.search,
                            id_status_laudo: this.status_selec ? this.status_selec.id_status_laudo : null,
                            id_amostra_rastro_status: this.status_selec_arquivo ? this.status_selec_arquivo.id_amostra_rastro_status : null,
                            id_fila_laudo: this.fila ? this.fila.id_fila_laudo : null,
                            lidas: lidas,
                            removidas: removidas,
                            tipo_leitura: this.tipo_leitura, 
                            modelo: this.modelo,
                            resps: this.resps ? this.resps.resps : null,
                            dt_prazo: this.status_selec_arquivo ? this.status_selec_arquivo.dt_prazo : null,
                            js_formulario: ( this.status_selec_arquivo && this.status_selec_arquivo.js_formulario && this.status_selec_arquivo.js_formulario.length ) 
                                ? this.status_selec_arquivo.js_formulario : null,
                            id_tipo_etiqueta_amostra: this.id_eta ? this.id_eta : null,
                            force_unico: ( ( this.todos_unico == 'U' ) || force_unico ) ? true : false, 
                        },
                        callback: res => { 
                            console.log('retorno leitura amostra', res);

                            if ( res && res.amostra && res.amostra.id_amostra ) { 
                                if ( existe ) { 
                                    this.$set(this.lista, 0, res.amostra);    
                                } else { 
                                    this.lista.unshift(res.amostra); 
                                }
                            }
                        }
                    });

                }

            }
            
            this.$nextTick(() => { 
                this.search = "";
            });
        },

        abrir (amostras = null, codamostra = null) { 

            this.validate = false; 
            this.status_selec = null;
            this.status_selec_arquivo = null;
            this.resps = { resps: [] };
            this.id_eta = this.id_tipo_etiqueta_amostra; 

            if ( !amostras && !codamostra ) { 

                this.lista = []; 
                
            } else { 

                this.lista = _.cloneDeep(amostras);

                let item = this.lista.find(a => a.st_codigo == ( codamostra ? codamostra.trim() : '-')); 

                if ( item ) { 
                    item.fl_ativo = false;
                }

            }

            $('#lerAmostrasAPModal').modal('show');

            setTimeout(() => { 
                if ( this.$refs.barcode ) { 
                    this.$refs.barcode.$refs.input.focus(); 
                }
            }, 500);

        }

    },

    beforeMount() { 
        if ( this.only_amostras ) { 
            this.tipo_leitura = 'A'; 
            this.carregar_status_amostra(); 
        }
    }

}
</script>
